// components
import { styled } from '@mui/material';
import { MotionSlideIn } from './FlexMatchFilters.motion';

export const StyledAddRowMotionBoxNoPadding = styled(MotionSlideIn)(
  ({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);

export const StyledAddRowMotionBoxNoPaddingColumns = styled(
  StyledAddRowMotionBoxNoPadding
)(() => ({
  flexDirection: 'column'
}));

export const StyledAddRowMotionBoxNoPaddingBase = styled(MotionSlideIn)(
  ({ theme }) => ({
    width: '100%',
    display: 'flex',
    gap: theme.spacing(2)
  })
);
